import * as Helper from "../utils/helpers";
import DafMark from "./daf-mark";

export default class PostPaginate {
    constructor() {
        this.currentPage = 1;
        this.perPage = $(".post-paginate").data("per-page");
        this.postType = $(".post-paginate").data("type");
        this.sortBy = "";
        this.userCurrentList = $('.user-current__list');
        this.tabIndex = 1;
        this.addEvents();
    }

    addEvents() {
        let self = this;

        $(document).ready(function() {
            self.fetchPosts(1, true);
            changeMultilangSelect();
        })

        $(".post-paginate__sort > span em").on("click", function (e) {
            e.preventDefault();
            let list = $(this).parents(".post-paginate__sort");
            list.toggleClass("open");
        });

        $(".post-paginate__sort--item:not(.searchSort)").on("click", function (e) {
            e.preventDefault();
            let value = $(this).text().trim();
            let sortBy = $(this).data('sortby').trim();
            let list = $(this).parents(".post-paginate__sort");
            list.toggleClass("open");
            list.find("span em").html(value);
            self.sortBy = sortBy.toLowerCase().replace(/\s+/g, "-");
            let user_current_list_sort = $(this).parents('.user-post-paginate__sort').length ? true : false;
            self.fetchPosts(self.currentPage,true,user_current_list_sort);
            $(this).parent().find('.active').removeClass('active');
            $(this).addClass('active');
        });

        $(document).on("click", ".post-paginate__pagination .page-numbers", function (e) {
            e.preventDefault();
            let currentPage = 1;
            if($(this).hasClass('next')){
                currentPage =  parseInt($('.post-paginate__pagination .current').text()) + 1;
            } else if($(this).hasClass('prev')){
                currentPage =  parseInt($('.post-paginate__pagination .current').text()) - 1
            } else {
                currentPage = $(this).text();
            }
            if (!currentPage) return;
            let user_current_list_sort = $(this).parents('.user-current').length ? true : false;
            self.fetchPosts(currentPage, true,user_current_list_sort);
        });

        function changeMultilangSelect(){
            if($('ul').hasClass('learn-masechet__hero--nav') && $('html').attr('lang') == 'he-IL'){
                $('.learn-masechet__hero--nav .wp-block-navigation-item__content').each(function (ii,ee){
                    let currentLink = $(this).attr('href');
                    currentLink = currentLink.replace("/masechet/", "/he/masechet/");
                    $(this).attr('href', currentLink);
                })
            }
        }

        this.initAuthorPostTypeSelectors();
    }

    fetchPosts(page = 1, reset = false, userCurrentListSort = false) {
        let ajaxurl = myAjax.ajaxurl;
        let self = this;

        if(self.userCurrentList.length && userCurrentListSort){
            console.log('1');
            const current_user = $('.user-current');
            let adminID = current_user.data('page-id')
            $.ajax({
                url: ajaxurl,
                type: 'GET',
                data: {
                    action: 'user_current_list_shortcode',
                    sort: self.sortBy,
                    per_page: self.perPage,
                    adminID: adminID,
                    tabIndex: self.tabIndex,
                    paged: page,
                },
                beforeSend: function () {
                    if (reset) {
                        $(".user-current__list").css("opacity", "0.5");
                    }
                },
                success: function (response) {
                    $(".user-current__list").css("opacity", "1");
                    if (reset) {
                        $(".user-current__list").html(response);
                    } else {
                        $(".user-current__list").append(response);
                    }

                    $('.user-current__tab.active').trigger('click')
                    self.currentPage = page;

                    Helper.setAnimatedIcon(true);
                    new DafMark();

                },
                error: function () {
                    console.error("Error fetching posts.");
                },
            });
        } else if($('.post-paginate__content').length){
            let post_paginate = $('.post-paginate.authors');
            if(post_paginate.length == 0){
                post_paginate = $('.post-paginate.siyum');
            }
            post_paginate.each(function () {
                const atts = $(this).data();
                const post_content = $(this).find(".post-paginate__content");

                $.ajax({
                    url: ajaxurl,
                    type: 'POST',

                    data: {
                        action: 'post_paginate_shortcode',
                        type: self.postType,
                        sort: self.sortBy,
                        per_page: self.perPage,
                        paged: page,
                        atts: atts
                    },
                    beforeSend: function () {
                        if (reset) {
                            post_content.css("opacity", "0.5");
                        }
                    },
                    success: function (response) {
                        $(".post-paginate__content").css("opacity", "1");
                        if (reset) {
                            post_content.html(response);
                        } else {
                            post_content.append(response);
                        }
                        self.currentPage = page;

                        Helper.setAnimatedIcon(true);
                    },
                    error: function () {
                        console.error("Error fetching posts.");
                    },
                });
            })
        }

    }

    initAuthorPostTypeSelectors() {
        const desktopTabs = $(".user-current__tab");
        const mobileSelector = $(".user-current__mobile");
        const mobileSelectorActivator = mobileSelector.find(".user-current__mobile__current");
        const self = this;

        if (desktopTabs.length > 0 && mobileSelector.length > 0) {
            let currentlySelectedTypeIndex = 1;

            desktopTabs.each(function (index, item) {
                if ($(item).hasClass("active")) {
                    activateContentByTypeIndex(index + 1);
                }
            });

            mobileSelector.find(".user-current__mobile__item").on("click", function (e) {
                e.preventDefault();
                activateContentByTypeIndex($(this).index() + 1);
            });

            if (mobileSelectorActivator.length > 0) {
                mobileSelectorActivator.on("click", function (e) {
                    e.preventDefault();
                    mobileSelector.toggleClass("open");
                });
            }

            desktopTabs.on("click", function (e) {
                e.preventDefault();
                activateContentByTypeIndex($(this).index() + 1);
            });

            function activateContentByTypeIndex(index) {
                currentlySelectedTypeIndex = index;
                const text = $(".user-current__tab:nth-child(" + index + ")").text();

                $(".user-current__item").removeClass("active");
                $(".user-current__item:nth-child(" + index + ")").addClass("active");

                $(".user-current__tab").removeClass("active");
                $(".user-current__tab:nth-child(" + index + ")").addClass("active");

                mobileSelector.removeClass("open");
                mobileSelectorActivator.text(text);
                self.tabIndex = index;
            }
        } else {
            console.warn("Author post types selector init skipping - missing elements");
        }
    }
}
